export default __webpack_public_path__ + "static/media/target-7@3x.19fd53e4.png";